import { useEffect, useState } from "react";
import { FormInstance, FormProps } from "antd";

/**
 * Возвращает объект значений формы, изменяющийся в реальном времени и onValuesChange для передачи в form.
 * @formData объект значений формы, изменяющийся в реальном времени
 * @onValuesChange Передать в form.
 * @warn Стоит учитывать, что onValuesChange срабатывает только при внесении изменений в форму непосредственно (т.е. изменение путем вызова form.setFiledValues() не сохранится, т.к. оно не вызывает onValuesChange формы)
 * @setFormFieldsValue Изменяет значение в форме и в formData
 * @resetFormFields Сброс формы и значений в formData
 */

export const useFormData = <DataType>(params: {
  form: FormInstance<DataType>;
  initialValues?: Partial<DataType>;
}) => {
  const { form, initialValues } = params;
  const [formData, setFormData] = useState<Partial<DataType>>();

  const resetFormFields = () => {
    if (initialValues) {
      setFormData(initialValues);
      form.resetFields();
      setTimeout(() => {
        // @ts-ignore
        form.setFieldsValue(initialValues);
      }, 500);
    } else {
      setFormData(undefined);
      form.resetFields();
    }
  };

  // Фиксация дефолтных значений формы
  useEffect(() => {
    resetFormFields();
  }, []);

  const onValuesChange: FormProps<DataType>["onValuesChange"] = (_, values) => {
    setFormData(values);
  };
  const setFormFieldsValue = (data: Partial<DataType>) => {
    // @ts-ignore
    form.setFieldsValue(data);
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
  };

  return { formData, onValuesChange, setFormFieldsValue, resetFormFields };
};
